import React, { useEffect, useState } from "react";
import {
  fill_heart,
  heart_icon,
  lock_icon,
  subscription_icon,
} from "../../../../assets";
import { Link, useNavigate } from "react-router-dom";
import { groupListingApi, joinGroupApi } from "../../../../services/groups";
import InfiniteScroll from "react-infinite-scroll-component";
import useDebounce from "../../../../hooks/useDebounce";
import { GoDotFill } from "react-icons/go";
import { updateFavoriteListHandler } from "./LikeUnlikeHeart";
import { GroupCardSkeleton } from "../../../../shimmer/groups/GroupsListingShimmer";
import { Button, LoadingButton } from "../../../../components/header/form";
import { toastMessage } from "../../../../utils/toastMessage";
import SubscriptionPlan from "../subscription/SubscriptionPlan";
import NotFoundPlaceHolder from "../../../../components/not-found/NotFoundPlaceHolder";
import FlatList from "components/FlatList";
import LazyImage from "components/common/Image";

const ExploreGroup = ({ exploreSearch }) => {
  const [exploreGroupList, setExploreGroupList] = useState([]);
  const debouncedValue = useDebounce(exploreSearch, 300);
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [joinLoading, setJoinLoading] = useState(false);
  const [groupId, setGroupId] = useState("");
  const [subscriptionModal, setSubscriptionModal] = useState(false);
  const [loading, setLoading] = useState(false);

  console.log("exploreGroupList", exploreGroupList);
  //--------navigate-details-page--------------
  const navigateDetailsPage = (id) => {
    navigate(`/dashboard/group/detail/${id}`);
  };
  // ---------subscription-handler------------
  const handleSubscriptionJoin = (id) => {
    setGroupId(id);
    setSubscriptionModal(true);
  };
  // Rendering HTML Conditionally
  const renderHtml = (data) => {
    switch (data) {
      case "ACCEPTED":
        return (
          <Button disabled={true} className="join_button">
            Accepted
          </Button>
        );
      case "REQUESTED":
        return (
          <Button disabled={true} className="join_button">
            Request Sent
          </Button>
        );
      default:
        return null; // Handle cases where the level doesn't match
    }
  };

  const joinGroupHandler = async (_id) => {
    try {
      setJoinLoading(true);
      const { data } = await joinGroupApi({ _id });
      const { success, message, data: response } = data;
      if (success) {
        setPage(1);
        setHasMore(true);
        exploreGroupListHandler(1, true);
      }
      toastMessage(message, success ? "success" : "error", "joinHandler");
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setJoinLoading(false);
    }
  };

  //-----------------test-scrolling--------------------------------
  const exploreGroupListHandler = async (page = 1, isRefresh = false) => {
    try {
      setLoading(true);
      const { data } = await groupListingApi({
        type: "explore",
        pagination: "true",
        search: debouncedValue,
        limit: 20,
        page,
      });
      const { data: exploreList, success, message, meta } = data;
      if (success) {
        if (isRefresh) {
          setExploreGroupList(exploreList || []);
        } else {
          setExploreGroupList((prev) => [...prev, ...(exploreList || [])]);
        }
        setHasMore(exploreList.length === 20);
      }
    } catch (e) {
      console.log("Error:-", e.message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    setPage(1);
    setHasMore(true);
    exploreGroupListHandler(1, true);
  }, [debouncedValue]);

  const fetchMoreData = () => {
    setPage((prevPage) => {
      const nextPage = prevPage + 1;
      exploreGroupListHandler(nextPage);
      return nextPage;
    });
  };

  console.log({ exploreGroupList });


  return (
    <>
      <div className="CategoriesGroupsList_parent">
        <div id="scrollableContainer" className="CategoriesGroupsList_cards">
          {exploreGroupList.length > 0 || loading ? (
            <InfiniteScroll
              dataLength={exploreGroupList.length}
              next={fetchMoreData}
              hasMore={hasMore}
              loader={<GroupCardSkeleton count={5} />}
              scrollableTarget="scrollableContainer"
            >
              <div className="health_hub_cards">
                <FlatList
                  data={exploreGroupList}
                  renderItem={(data) => {
                    return (
                      <div key={data?._id} className="health_hub_img">
                        <div
                          onClick={() => navigateDetailsPage(data?._id)}
                          className="image_containerss pointer-cursor"
                        >
                          <LazyImage src={data?.coverImage} alt="" />
                          <div className="health_hub_img_text">
                            <h6>{data?.name}</h6>
                          </div>
                        </div>

                        <div className="health_hub_containt">
                          <div className="rgt_tan_wrap">
                            <span className="tag dark">{data?._parent?.name || data?.categoryName}</span>
                            {data?.request &&
                            Object.keys(data?.request).length > 0 ? (
                              renderHtml(data?.request?.status)
                            ) : data?.type === "SUBSCRIPTION" &&
                              data?.subscription?.status !== "ACTIVE" ? (
                              <Button
                                onClick={() =>
                                  handleSubscriptionJoin(data?._id)
                                }
                                type="button"
                                className="share_icon"
                              >
                                Subscribe
                              </Button>
                            ) : (
                              <LoadingButton
                                loading={groupId === data?._id && joinLoading}
                                className="join_button"
                                onClick={(e) => {
                                  setGroupId(data?._id);
                                  joinGroupHandler(data?._id);
                                  e.preventDefault();
                                }}
                              >
                                Join
                              </LoadingButton>
                            )}
                          </div>

                          <figure className="health_hub_icons">
                            {data?.type === "SUBSCRIPTION" && (
                              <img
                                src={subscription_icon}
                                className="lockimg"
                                alt=""
                              />
                            )}
                            {data?.type === "PRIVATE" && (
                              <img src={lock_icon} className="lockimg" alt="" />
                            )}
                            <img
                              src={
                                data?.favoriteGroup?.status === "ACTIVE"
                                  ? fill_heart
                                  : heart_icon
                              }
                              className="heartimg"
                              alt=""
                              onClick={() =>
                                updateFavoriteListHandler(
                                  data?._id,
                                  setExploreGroupList,
                                  data?.favoriteGroup?.status === "ACTIVE"
                                    ? "INACTIVE"
                                    : "ACTIVE"
                                )
                              }
                            />
                          </figure>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            </InfiniteScroll>
          ) : (
            <NotFoundPlaceHolder title="No Groups available" />
          )}
        </div>
      </div>

      {/* //--------subscription-modal-------- */}
      <SubscriptionPlan
        show={subscriptionModal}
        close={() => setSubscriptionModal(false)}
        id={groupId}
        listing={exploreGroupListHandler}
        setPage={setPage}
        setHasMore={setHasMore}
        type="list"
      />
    </>
  );
};

export default ExploreGroup;
